export const normalizeLocalizedField = (field, fallback = { es: '', en: '', pt: '' }) => {
  if (!field) return fallback;
  if (typeof field === 'string') {
    return { es: field, en: field, pt: field };
  }

  return { es: '', en: '', pt: '', ...field };
};

export const getLocalizedText = (field, currentLang) => {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return field[currentLang] || field.en || field.es || '';
};
